import React from 'react';
import { useSelector } from 'react-redux';
import { VertSkeleton, VertTypography } from '@vertem-core/vertice-ds';
import { LuUser2 } from 'react-icons/lu';


import PipeProvider from 'Services/Providers/PipeProvider';
import Icon from 'components/Atoms/Icons/Icon';
import { GreetingsUser } from 'structure/header//GreetingsUser';

const formatFirstName = ( name, isLoading ) => {
    let firstName = '';
    if (!isLoading) {
        if (name) {
            const { value } = name;
            const nameArray = value.split(' ');
            firstName = nameArray[0];
        }
    }
    return firstName;
}

const HeaderProfile = () => {
    const Participants = useSelector(({ Participants: data }) => data);

    const { name, isLoading: isLoadingParticipant  } = Participants;
    const isLoading = isLoadingParticipant;
    
    return (
        <PipeProvider
            apiSymbols={['FETCH_PARTICIPANT',]}
            loadingComponent={
                <div className="header-profile-name">
                    <VertSkeleton paragraph={{ rows: 1 }} active title={false} />
                </div>
            }
        >
            <div className="header-profile-name">
                <Icon className="lucide" size={`18px`} component={LuUser2} />
                <VertTypography.Paragraph>
                     { GreetingsUser(formatFirstName(name, isLoading)) }
                </VertTypography.Paragraph>
            </div>
        </PipeProvider>
    );
};

export default HeaderProfile;
